import { IFilteringViewModel } from "../_common/interface/table/iTableFilter.interface";

export const TABLE_FILTER: IFilteringViewModel = {
    search: "",
    pageIndex: 0,
    pageSize: 100,
    order: "asc",
    orderBy: ''
};